<template>
    <div class="dash" v-loading="loading">
        <div class="dash__aurora" />
        <div class="dash__inner">
            <div class="dash__banner">
                <span class="dash__banner-title">数据看板</span>
            </div>

            <section class="dash__today">
                <div class="dash__today-head">
                    <h2 class="dash__section-title">今日数据</h2>
                    <p class="dash__section-desc">{{ todayLabel }}</p>
                </div>
                <div class="dash__today-grid">
                    <div class="dash__today-item">
                        <div class="dash__today-label">今日新增</div>
                        <div class="dash__today-value">{{ metrics.today_new_orders || 0 }}</div>
                    </div>
                    <div class="dash__today-item">
                        <div class="dash__today-label">今日归档</div>
                        <div class="dash__today-value">{{ metrics.today_archived_orders || 0 }}</div>
                    </div>
                    <div class="dash__today-item">
                        <div class="dash__today-label">今日外派</div>
                        <div class="dash__today-value">{{ metrics.today_dispatched_orders || 0 }}</div>
                    </div>
                    <div class="dash__today-item">
                        <div class="dash__today-label">今日新增待收</div>
                        <div class="dash__today-value">￥{{ formatMoney(metrics.today_pending_amount) }}</div>
                    </div>
                </div>
            </section>

            <section class="dash__grid">
                <article
                    v-for="card in metricCards"
                    :key="card.key"
                    class="dash__stat"
                    :class="'dash__stat--' + card.tone"
                >
                    <div class="dash__stat-icon-wrap">
                        <i class="dash__stat-icon" :class="card.icon" />
                    </div>
                    <span class="dash__stat-label">{{ card.label }}</span>
                    <span class="dash__stat-value">{{ card.display }}</span>
                    <span class="dash__stat-hint">{{ card.tip }}</span>
                </article>
            </section>

            <section class="dash__finance">
                <div class="dash__finance-head">
                    <h2 class="dash__section-title">财务数据看板</h2>
                    <p class="dash__section-desc">自动汇总客户应收与渠道佣金数据</p>
                </div>
                <div class="dash__finance-grid">
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">应收总额</div>
                        <div class="dash__finance-value">￥{{ formatMoney(metrics.receivable_total) }}</div>
                    </div>
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">已收总额</div>
                        <div class="dash__finance-value">￥{{ formatMoney(metrics.paid_total) }}</div>
                    </div>
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">待收总额</div>
                        <div class="dash__finance-value">￥{{ formatMoney(metrics.pending_amount_total) }}</div>
                    </div>
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">累计待付佣金</div>
                        <div class="dash__finance-value">￥{{ formatMoney(metrics.commission_pending_total) }}</div>
                    </div>
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">累计已付佣金</div>
                        <div class="dash__finance-value">￥{{ formatMoney(metrics.commission_paid_total) }}</div>
                    </div>
                    <div class="dash__finance-item">
                        <div class="dash__finance-label">财务提醒</div>
                        <div class="dash__finance-value">{{ metrics.unread_alerts || 0 }}</div>
                    </div>
                </div>
                <div class="dash__finance-progress">
                    <div class="dash__finance-progress-top">
                        <span>超期风险占比</span>
                        <span>{{ financialRiskRate }}%</span>
                    </div>
                    <div class="dash__finance-progress-track">
                        <div class="dash__finance-progress-fill" :style="{ width: financialRiskRate + '%' }" />
                    </div>
                </div>
            </section>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            loading: false,
            metrics: {
                total_orders: 0,
                active_orders: 0,
                archived_orders: 0,
                abnormal_orders: 0,
                dispatched_orders: 0,
                work_enabled_orders: 0,
                field_work_processing: 0,
                financial_overdue_orders: 0,
                pending_amount_total: 0,
                commission_paid_total: 0,
                commission_pending_total: 0,
                today_new_orders: 0,
                today_archived_orders: 0,
                today_dispatched_orders: 0,
                today_pending_amount: 0,
                unread_alerts: 0
            },
            colorDistribution: {
                red: 0,
                yellow: 0,
                green: 0
            }
        };
    },
    computed: {
        todayLabel() {
            var now = new Date();
            var month = String(now.getMonth() + 1).padStart(2, '0');
            var day = String(now.getDate()).padStart(2, '0');
            return month + '-' + day + ' 实时更新';
        },
        metricCards() {
            var m = this.metrics;
            return [
                {
                    key: 'total_orders',
                    label: '订单总数',
                    display: m.total_orders || 0,
                    tip: '系统累计',
                    tone: 'slate',
                    icon: 'el-icon-document'
                },
                {
                    key: 'active_orders',
                    label: '待处理中',
                    display: m.active_orders || 0,
                    tip: '未归档',
                    tone: 'blue',
                    icon: 'el-icon-time'
                },
                {
                    key: 'archived_orders',
                    label: '已完成数',
                    display: m.archived_orders || 0,
                    tip: '已归档订单',
                    tone: 'green',
                    icon: 'el-icon-success'
                },
                {
                    key: 'dispatched_orders',
                    label: '外派处理中',
                    display: m.dispatched_orders || 0,
                    tip: '已外派待接收',
                    tone: 'red',
                    icon: 'el-icon-s-promotion'
                },
                {
                    key: 'field_work_processing',
                    label: '外勤处理中',
                    display: m.field_work_processing || 0,
                    tip: '未归档且已开启外勤',
                    tone: 'violet',
                    icon: 'el-icon-location-outline'
                }
            ];
        },
        financialRiskRate() {
            var active = Number(this.metrics.active_orders || 0);
            if (active <= 0) {
                return 0;
            }
            var overdue = Number(this.metrics.financial_overdue_orders || 0);
            var rate = (overdue / active) * 100;
            return Math.round(rate * 10) / 10;
        }
    },
    created() {
        this.fetchDashboard();
    },
    methods: {
        formatMoney(value) {
            return Number(value || 0).toFixed(2);
        },
        fetchDashboard() {
            var _this = this;

            this.loading = true;
            window.axios.get('/dashboard/summary').then(function (response) {
                var data = response.data.data || {};
                _this.metrics = Object.assign(_this.metrics, data.metrics || {});
                _this.colorDistribution = Object.assign(_this.colorDistribution, data.color_distribution || {});
            }).catch(function () {
                _this.$message.error('数据看板加载失败');
            }).finally(function () {
                _this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.dash {
    min-height: 100%;
    position: relative;
    overflow: hidden;
    background:
        radial-gradient(circle at 10% -20%, rgba(59, 130, 246, 0.13), rgba(59, 130, 246, 0) 45%),
        radial-gradient(circle at 95% 10%, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0) 42%),
        linear-gradient(180deg, #f8fafc 0%, #f2f7ff 100%);
    padding: 30px 24px 52px;
}

.dash__aurora {
    position: absolute;
    top: -180px;
    right: -120px;
    width: 420px;
    height: 420px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0) 72%);
    pointer-events: none;
}

.dash__inner {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    z-index: 1;
}

.dash__banner {
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(148, 163, 184, 0.18);
    box-shadow: 0 6px 14px -10px rgba(15, 23, 42, 0.3);
}

.dash__banner-title {
    font-size: 16px;
    font-weight: 700;
    color: #1f2d3d;
    letter-spacing: 0.3px;
}

.dash__head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 28px;
    padding: 10px 14px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.62);
    backdrop-filter: blur(2px);
    border: 1px solid rgba(148, 163, 184, 0.15);
}

.dash__title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #0f172a;
}

.dash__lead {
    margin: 6px 0 0;
    font-size: 13px;
    color: #6f7d92;
    font-weight: 400;
}

.dash__grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-bottom: 16px;
}

.dash__today {
    background: #fff;
    border-radius: 16px;
    padding: 14px 18px;
    box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 18px 28px -18px rgba(59, 130, 246, 0.35);
    border: 1px solid rgba(226, 232, 240, 0.75);
    margin-bottom: 14px;
}

.dash__today-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-top: 10px;
}

.dash__today-item {
    border-radius: 10px;
    border: 1px solid #e8edf7;
    background: #f8fbff;
    padding: 10px 12px;
}

.dash__today-label {
    font-size: 12px;
    color: #718096;
}

.dash__today-value {
    margin-top: 4px;
    font-size: 24px;
    line-height: 1.1;
    font-weight: 700;
    color: #111827;
    font-variant-numeric: tabular-nums;
}

.dash__finance {
    background: #fff;
    border-radius: 16px;
    padding: 20px 24px 18px;
    box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 18px 28px -18px rgba(59, 130, 246, 0.35);
    border: 1px solid rgba(226, 232, 240, 0.75);
    margin-bottom: 14px;
}

.dash__finance-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-top: 14px;
}

.dash__finance-item {
    background: #f8fbff;
    border: 1px solid #e6eef8;
    border-radius: 12px;
    padding: 12px 14px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.dash__finance-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px -12px rgba(15, 23, 42, 0.45);
}

.dash__finance-label {
    font-size: 12px;
    color: #76859b;
}

.dash__finance-value {
    margin-top: 6px;
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    font-variant-numeric: tabular-nums;
}

.dash__finance-progress {
    margin-top: 14px;
}

.dash__finance-progress-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #64748b;
    margin-bottom: 8px;
}

.dash__finance-progress-track {
    height: 12px;
    border-radius: 999px;
    background: #eef2f7;
    overflow: hidden;
}

.dash__finance-progress-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, #f59e0b, #f97316);
    transition: width 0.35s ease;
}

@media (max-width: 1100px) {
    .dash__grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 900px) {
    .dash__grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 520px) {
    .dash__grid {
        grid-template-columns: 1fr;
    }
}

.dash__stat {
    background: #fff;
    position: relative;
    border-radius: 16px;
    padding: 20px 20px 16px;
    box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 18px 28px -18px rgba(59, 130, 246, 0.35);
    border: 1px solid rgba(226, 232, 240, 0.7);
    transition: transform 0.22s ease, box-shadow 0.22s ease;
    overflow: hidden;
}

.dash__stat:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 22px -8px rgba(15, 23, 42, 0.12), 0 20px 30px -16px rgba(59, 130, 246, 0.4);
}

.dash__stat::after {
    content: '';
    position: absolute;
    right: -36px;
    top: -36px;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(99, 102, 241, 0.06);
}

.dash__stat-icon-wrap {
    position: absolute;
    right: 14px;
    top: 14px;
    width: 38px;
    height: 38px;
    border-radius: 11px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(99, 102, 241, 0.08);
}

.dash__stat-icon {
    font-size: 18px;
    color: rgba(71, 85, 105, 0.7);
}

.dash__stat-label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #94a3b8;
}

.dash__stat-value {
    display: block;
    margin-top: 10px;
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: #0f172a;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}

.dash__stat-hint {
    display: block;
    margin-top: 6px;
    font-size: 11px;
    color: #b0bccd;
}

.dash__stat--red .dash__stat-value {
    color: #b91c1c;
}

.dash__stat--green .dash__stat-value {
    color: #15803d;
}

.dash__stat--blue .dash__stat-value {
    color: #1d4ed8;
}

.dash__stat--violet .dash__stat-value {
    color: #6d28d9;
}

.dash__spectrum {
    background: #fff;
    border-radius: 16px;
    padding: 12px 18px 12px;
    box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 18px 28px -18px rgba(59, 130, 246, 0.35);
    border: 1px solid rgba(226, 232, 240, 0.75);
}

.dash__section-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
}

.dash__section-desc {
    margin: 2px 0 0;
    font-size: 11px;
    color: #9ca3af;
}

.dash__spectrum-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-top: 10px;
}

@media (max-width: 640px) {
    .dash__today-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dash__finance-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dash__spectrum-row {
        grid-template-columns: 1fr;
        gap: 14px;
    }
}

.dash__spectrum-item {
    border-radius: 12px;
    padding: 4px 6px 2px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.dash__spectrum-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px -12px rgba(15, 23, 42, 0.35);
}

.dash__spectrum-top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 4px;
}

.dash__spectrum-name {
    font-size: 12px;
    font-weight: 600;
}

.dash__spectrum-name--red {
    color: #dc2626;
}

.dash__spectrum-name--yellow {
    color: #ca8a04;
}

.dash__spectrum-name--green {
    color: #16a34a;
}

.dash__spectrum-num {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    font-variant-numeric: tabular-nums;
}

.dash__spectrum-track {
    height: 8px;
    background: #eef2f7;
    border-radius: 999px;
    overflow: hidden;
}

.dash__spectrum-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 0.35s ease, filter 0.2s ease;
}

.dash__spectrum-item:hover .dash__spectrum-fill {
    filter: brightness(1.04);
}

.dash__spectrum-fill--red {
    background: linear-gradient(90deg, #f87171, #ef4444);
}

.dash__spectrum-fill--yellow {
    background: linear-gradient(90deg, #fdba74, #f59e0b);
}

.dash__spectrum-fill--green {
    background: linear-gradient(90deg, #4ade80, #22c55e);
}

.dash__spectrum-pct {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: #9ca3af;
    font-variant-numeric: tabular-nums;
}

@media (max-width: 700px) {
    .dash {
        padding: 22px 14px 30px;
    }

    .dash__head {
        align-items: flex-start;
        gap: 12px;
    }

    .dash__title {
        font-size: 20px;
    }

    .dash__finance-grid {
        grid-template-columns: 1fr;
    }

    .dash__today-grid {
        grid-template-columns: 1fr;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Home.vue